import React, { createContext, RefObject } from 'react';

type ProjectsTreeContextType = {
    editProjectStatuses: Set<string | undefined>;
    registerCell: (itemId: string, cell: RefObject<HTMLDivElement>) => void;
    unregisterCell: (itemId: string, cell: RefObject<HTMLDivElement>) => void;

    sharedCellProps: {
        onMouseEnter: (e: React.MouseEvent<HTMLDivElement>) => void;
        onMouseLeave: (e: React.MouseEvent<HTMLDivElement>) => void;
        onDragOver: (e: React.DragEvent<HTMLDivElement>) => void;
        onDragLeave: (e: React.DragEvent<HTMLDivElement>) => void;
        onDragEnter: (e: React.DragEvent<HTMLDivElement>) => void;
        onDragStart: (e: React.DragEvent<HTMLDivElement>) => void;
        onDragEnd: (e: React.DragEvent<HTMLDivElement>) => void;
        onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
    };
};

export const ProjectsTreeContext = createContext<ProjectsTreeContextType | null>(null);
